import React from "react";
import SelectedDataLakesContext from "data-lake/contexts/SelectedDataLakesContext";
import { INTERNAL_DATA_LAKE_INFO } from "data-lake/Constants";
const contextValue = {
  selectedDataLake: INTERNAL_DATA_LAKE_INFO
};
const SelectedInternalDataLakeProvider = ({ children = void 0 }) => /* @__PURE__ */ React.createElement(SelectedDataLakesContext.Provider, { value: contextValue }, children);
export default SelectedInternalDataLakeProvider;
